var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportsDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.5,
    height: 65.5,
    viewBox: "0 0 65.5 65.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ReportsDashboard_Icon",
    "data-name": "ReportsDashboard Icon",
    transform: "translate(-17.912 -17.958)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(18.662 18.708)",
    fill: "#fff",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2686",
    "data-name": "Group 2686",
    transform: "translate(34.408 29.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M81.383,73.769H79.036v-.853q-.007-16.991-.019-33.983c0-.666-.034-1.241-.814-1.241-8.281.024-16.558.01-24.839.034-.68,0-.929-.144-.905-.867.053-1.595.014-1.595,1.667-1.595q12.961,0,25.927,0c1.442,0,1.413,0,1.37,1.418-.048,1.537-.038,25.778-.034,36.363v.723Z",
    transform: "translate(-48.928 -35.26)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M74.2,74.742q0-15.871.034-31.741c0-.551-.2-.718-.709-.714-1.063,0-2.122-.024-3.185-.029q-11.179-.029-22.363-.048H45.09V80.839a2.826,2.826,0,0,0,.292.034q14.082,0,28.168.014c.513,0,.685-.177.68-.661-.024-1.825-.038-3.655-.034-5.479ZM48.448,52.23c.024-1.116.01-2.232.01-3.353h-.024c0-1.15.01-2.3,0-3.453,0-.278.086-.378.354-.378,2.328,0,4.66,0,6.988.019.115,0,.326.244.33.378.014,2.27,0,4.536,0,6.806,0,.316-.105.426-.426.426-2.261-.01-4.521-.014-6.777,0-.34,0-.455-.1-.45-.45Zm23.235-.522a.576.576,0,0,1-.575.575H61.337a.576.576,0,0,1-.575-.575v-.685a.576.576,0,0,1,.575-.575h9.771a.576.576,0,0,1,.575.575Zm0-5.4a.576.576,0,0,1-.575.575H61.337a.576.576,0,0,1-.575-.575v-.685a.576.576,0,0,1,.575-.575h9.771a.576.576,0,0,1,.575.575Z",
    transform: "translate(-45.09 -38.881)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M54.14,84.191l-.11-.532,4.4-.939,5.063-3.971,4.4,3.664L72.839,75.9l.436.33L67.982,83.2l-4.5-3.755-4.814,3.779Z",
    transform: "translate(-49.748 -56.435)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M53.14,51.415l2.309,3.875,4.306-6.37-4.392,4.517Z",
    transform: "translate(-49.284 -42.377)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 1.078,
    cy: 1.078,
    r: 1.078,
    transform: "translate(12.578 21.961)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 1.078,
    cy: 1.078,
    r: 1.078,
    transform: "translate(16.936 25.175)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 1.078,
    cy: 1.078,
    r: 1.078,
    transform: "translate(21.903 18.704)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 1.078,
    cy: 1.078,
    r: 1.078,
    transform: "translate(3.382 26.559)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_673",
    "data-name": "Rectangle 673",
    width: 3.554,
    height: 7.817,
    transform: "translate(2.333 32.019)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_674",
    "data-name": "Rectangle 674",
    width: 3.554,
    height: 5.978,
    transform: "translate(7.458 33.858)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_675",
    "data-name": "Rectangle 675",
    width: 3.554,
    height: 10.025,
    transform: "translate(12.587 29.811)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M89.258,117.836H88.64v-.364h.206v-.182h.412Z",
    transform: "translate(-67.781 -78)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_676",
    "data-name": "Rectangle 676",
    width: 0.91,
    height: 0.364,
    transform: "translate(19.039 39.472)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M82.263,117.836H81.65v-.546h.412v.182h.2Z",
    transform: "translate(-64.139 -78)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M82.062,107.426H81.65v-.7h.412Zm0-1.4H81.65v-.7h.412Zm0-1.4H81.65v-.7h.412Zm0-1.4H81.65v-.7h.412Zm0-1.4H81.65v-.7h.412Zm0-1.4H81.65v-.7h.412Z",
    transform: "translate(-64.139 -68.84)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M82.062,97.656H81.65V97.11h.613v.364h-.2Z",
    transform: "translate(-64.139 -67.486)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_677",
    "data-name": "Rectangle 677",
    width: 0.91,
    height: 0.364,
    transform: "translate(19.039 29.624)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M89.258,97.656h-.412v-.182H88.64V97.11h.618Z",
    transform: "translate(-67.781 -67.486)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M89.482,107.426H89.07v-.7h.412Zm0-1.4H89.07v-.7h.412Zm0-1.4H89.07v-.7h.412Zm0-1.4H89.07v-.7h.412Zm0-1.4H89.07v-.7h.412Zm0-1.4H89.07v-.7h.412Z",
    transform: "translate(-68.005 -68.84)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_678",
    "data-name": "Rectangle 678",
    width: 3.554,
    height: 13.066,
    transform: "translate(22.842 26.77)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M59.5,70.737V67.02h.077a3.61,3.61,0,0,1,3.109,1.8l.038.067L59.5,70.742Zm.148-3.568v3.3l2.864-1.652a3.447,3.447,0,0,0-2.864-1.652Z",
    transform: "translate(-52.598 -51.808)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M52.687,74.347l-.038-.067a3.572,3.572,0,0,1-.479-1.791,3.608,3.608,0,0,1,.479-1.791l.038-.067,3.219,1.858Zm.057-3.511a3.416,3.416,0,0,0,0,3.3l2.864-1.652Z",
    transform: "translate(-48.779 -53.689)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M56.309,70.732,53.09,68.873l.038-.067a3.6,3.6,0,0,1,3.109-1.8h.077v3.717ZM53.3,68.821l2.864,1.652v-3.3A3.453,3.453,0,0,0,53.3,68.82Z",
    transform: "translate(-49.258 -51.803)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M64.371,70.84,61.33,72.6l3.041,1.758a3.526,3.526,0,0,0,0-3.516Z",
    transform: "translate(-53.552 -53.798)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M64.239,74.347,61.02,72.488l3.219-1.858.038.067a3.572,3.572,0,0,1,.479,1.791,3.608,3.608,0,0,1-.479,1.791Zm-2.917-1.858,2.864,1.652a3.419,3.419,0,0,0,.421-1.652,3.473,3.473,0,0,0-.421-1.652Z",
    transform: "translate(-53.39 -53.689)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M59.567,77.957H59.49V74.24L62.709,76.1l-.038.067a3.6,3.6,0,0,1-3.109,1.8Zm.077-3.458v3.3a3.453,3.453,0,0,0,2.864-1.652L59.643,74.5Z",
    transform: "translate(-52.593 -55.57)",
    fill: "#f0d8c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M56.3,77.952h-.077a3.61,3.61,0,0,1-3.109-1.8l-.038-.067L56.3,74.23v3.717Zm-3.013-1.806A3.447,3.447,0,0,0,56.155,77.8v-3.3Z",
    transform: "translate(-49.253 -55.565)",
    fill: "#f0d8c7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsDashboard);
export default __webpack_public_path__ + "static/media/ReportsDashboard.eb51070e8974a29d6418041e6ffaa644.svg";
export { ForwardRef as ReactComponent };